import React, { FC, memo, useCallback } from "react";
import { useCurrencySymbol } from "hooks/useCurrencySymbol";
import { Map } from "immutable";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { compose } from "redux";
import { createStructuredSelector } from "reselect";
import { OpenRightPanel } from "types/common/rightPanel";
import { openRightPanel } from "../../../../reduxFolder/reducers/rightPanel";
import {
  panelSelectData,
  panelSelectOpened,
} from "../../../../reduxFolder/selectors/rightPanelSelectors";
import Logo from "../../../../components/Logo/Logo";
import { Currency, ParcelCol } from "../../../../styles/parcelsStyles";
import formatter from "../../../../utils/formatter";
import { HistoryRow, Price, VertLine } from "./WeekComponents.styles";

interface ManifestRowProps {
  manifest: any;
  units: string;
  panelData: any;
  isPanelOpened: boolean;
  openRightPanel: OpenRightPanel;
}

const ManifestRow: FC<ManifestRowProps> = ({
  manifest,
  units,
  openRightPanel,
  isPanelOpened,
  panelData,
}) => {
  const { t } = useTranslation("common");
  const currencySymbol = useCurrencySymbol();
  const manifestId = manifest.get("id");
  const batchNumber = manifest.get("batch_number");
  const shipperName = manifest.getIn(["manifest_shipper", "name"], "");
  const logoUrl = manifest.getIn(["manifest_shipper", "shipper_service", "logo_url"], "");
  const ordersCount = manifest.get("orders_count");
  const totalWeight = manifest.get("total_weight", 0);
  const totalPrice = manifest.get("total_price", 0);

  const isSelected =
    isPanelOpened && panelData.get("manifestId") === manifestId;

  const handleClick = useCallback(
    () =>
      openRightPanel(
        "MANIFEST_DETAIL",
        Map({ manifestId, batchNumber, shipperName, logoUrl }),
      ),
    [openRightPanel, manifestId, batchNumber, shipperName, logoUrl],
  );

  return (
    <HistoryRow selected={isSelected} onClick={handleClick}>
      <ParcelCol xs={5} lg={5} style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {logoUrl && <Logo image={logoUrl} size={20} />}
        <strong>{shipperName}</strong>
        <VertLine>|</VertLine>
        {batchNumber}
      </ParcelCol>
      <ParcelCol xs={3} lg={3}>
        {ordersCount !== null ? ordersCount : "—"}{" "}
        {ordersCount === 1 ? t("parcels.parcel") : t("parcels.parcels")}
      </ParcelCol>
      <ParcelCol xs={2} lg={2}>
        {Number(totalWeight).toFixed(2)} {t(`units.${units}.primaryShort`)}
      </ParcelCol>
      <ParcelCol xs={2} lg={2}>
        <Price>
          <Currency>{currencySymbol}</Currency> {formatter.currency(totalPrice)}
        </Price>
      </ParcelCol>
    </HistoryRow>
  );
};

const withConnect = connect(
  createStructuredSelector({
    isPanelOpened: panelSelectOpened,
    panelData: panelSelectData,
  }),
  { openRightPanel },
);

export default compose(withConnect, memo)(ManifestRow) as any;
